/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ʻaneafi",
        "-2": "ʻaneheafi",
        "0": "ʻahó ni",
        "1": "ʻapongipongi",
        "2": "ʻahepongipongi",
        "future": {
          "other": "ʻi he ʻaho ʻe {0}"
        },
        "past": {
          "other": "ʻaho ʻe {0} kuoʻosi"
        }
      },
      "day-narrow": {
        "-1": "ʻaneafi",
        "-2": "ʻaneheafi",
        "0": "ʻahó ni",
        "1": "ʻapongipongi",
        "2": "ʻahepongipongi",
        "future": {
          "other": "ʻi he ʻaho ʻe {0}"
        },
        "past": {
          "other": "ʻaho ʻe {0} kuoʻosi"
        }
      },
      "day-short": {
        "-1": "ʻaneafi",
        "-2": "ʻaneheafi",
        "0": "ʻahó ni",
        "1": "ʻapongipongi",
        "2": "ʻahepongipongi",
        "future": {
          "other": "ʻi he ʻaho ʻe {0}"
        },
        "past": {
          "other": "ʻaho ʻe {0} kuoʻosi"
        }
      },
      "hour": {
        "0": "ko e houa ʻeni",
        "future": {
          "other": "ʻi he houa ʻe {0}"
        },
        "past": {
          "other": "houa ʻe {0} kuoʻosi"
        }
      },
      "hour-narrow": {
        "0": "ko e houa ʻeni",
        "future": {
          "other": "ʻi he houa ʻe {0}"
        },
        "past": {
          "other": "houa ʻe {0} kuoʻosi"
        }
      },
      "hour-short": {
        "0": "ko e houa ʻeni",
        "future": {
          "other": "ʻi he houa ʻe {0}"
        },
        "past": {
          "other": "houa ʻe {0} kuoʻosi"
        }
      },
      "minute": {
        "0": "ko e miniti ʻeni",
        "future": {
          "other": "ʻi he miniti ʻe {0}"
        },
        "past": {
          "other": "miniti ʻe {0} kuoʻosi"
        }
      },
      "minute-narrow": {
        "0": "ko e miniti ʻeni",
        "future": {
          "other": "ʻi he miniti ʻe {0}"
        },
        "past": {
          "other": "miniti ʻe {0} kuoʻosi"
        }
      },
      "minute-short": {
        "0": "ko e miniti ʻeni",
        "future": {
          "other": "ʻi he miniti ʻe {0}"
        },
        "past": {
          "other": "miniti ʻe {0} kuoʻosi"
        }
      },
      "month": {
        "-1": "māhina kuoʻosi",
        "0": "māhiná ni",
        "1": "māhina kahaʻu",
        "future": {
          "other": "ʻi he māhina ʻe {0}"
        },
        "past": {
          "other": "māhina ʻe {0} kuoʻosi"
        }
      },
      "month-narrow": {
        "-1": "māhina kuoʻosi",
        "0": "māhiná ni",
        "1": "māhina kahaʻu",
        "future": {
          "other": "ʻi he māhina ʻe {0}"
        },
        "past": {
          "other": "māhina ʻe {0} kuoʻosi"
        }
      },
      "month-short": {
        "-1": "māhina kuoʻosi",
        "0": "māhiná ni",
        "1": "māhina kahaʻu",
        "future": {
          "other": "ʻi he māhina ʻe {0}"
        },
        "past": {
          "other": "māhina ʻe {0} kuoʻosi"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "kuata kuoʻosi",
        "0": "kuata koʻeni",
        "1": "kuata hoko",
        "future": {
          "other": "ʻi he kuata ʻe {0}"
        },
        "past": {
          "other": "kuata ʻe {0} kuoʻosi"
        }
      },
      "quarter-narrow": {
        "-1": "kuata kuoʻosi",
        "0": "kuata koʻeni",
        "1": "kuata hoko",
        "future": {
          "other": "ʻi he kuata ʻe {0}"
        },
        "past": {
          "other": "kuata ʻe {0} kuoʻosi"
        }
      },
      "quarter-short": {
        "-1": "kuata kuoʻosi",
        "0": "kuata koʻeni",
        "1": "kuata hoko",
        "future": {
          "other": "ʻi he kuata ʻe {0}"
        },
        "past": {
          "other": "kuata ʻe {0} kuoʻosi"
        }
      },
      "second": {
        "0": "taimí ni",
        "future": {
          "other": "ʻi he sekoni ʻe {0}"
        },
        "past": {
          "other": "sekoni ʻe {0} kuoʻosi"
        }
      },
      "second-narrow": {
        "0": "taimí ni",
        "future": {
          "other": "ʻi he sekoni ʻe {0}"
        },
        "past": {
          "other": "sekoni ʻe {0} kuoʻosi"
        }
      },
      "second-short": {
        "0": "taimí ni",
        "future": {
          "other": "ʻi he sekoni ʻe {0}"
        },
        "past": {
          "other": "sekoni ʻe {0} kuoʻosi"
        }
      },
      "week": {
        "-1": "uike kuoʻosi",
        "0": "uiké ni",
        "1": "uike kahaʻu",
        "future": {
          "other": "ʻi he uike ʻe {0}"
        },
        "past": {
          "other": "uike ʻe {0} kuoʻosi"
        }
      },
      "week-narrow": {
        "-1": "uike kuoʻosi",
        "0": "uiké ni",
        "1": "uike kahaʻu",
        "future": {
          "other": "ʻi he uike ʻe {0}"
        },
        "past": {
          "other": "uike ʻe {0} kuoʻosi"
        }
      },
      "week-short": {
        "-1": "uike kuoʻosi",
        "0": "uiké ni",
        "1": "uike kahaʻu",
        "future": {
          "other": "ʻi he uike ʻe {0}"
        },
        "past": {
          "other": "uike ʻe {0} kuoʻosi"
        }
      },
      "year": {
        "-1": "taʻu kuoʻosi",
        "0": "taʻú ni",
        "1": "taʻu kahaʻu",
        "future": {
          "other": "ʻi he taʻu ʻe {0}"
        },
        "past": {
          "other": "taʻu ʻe {0} kuoʻosi"
        }
      },
      "year-narrow": {
        "-1": "taʻu kuoʻosi",
        "0": "taʻú ni",
        "1": "taʻu kahaʻu",
        "future": {
          "other": "ʻi he taʻu ʻe {0}"
        },
        "past": {
          "other": "taʻu ʻe {0} kuoʻosi"
        }
      },
      "year-short": {
        "-1": "taʻu kuoʻosi",
        "0": "taʻú ni",
        "1": "taʻu kahaʻu",
        "future": {
          "other": "ʻi he taʻu ʻe {0}"
        },
        "past": {
          "other": "taʻu ʻe {0} kuoʻosi"
        }
      }
    },
    "locale": "to"
  });
}